import {
  INSIDER_TRANSACTIONS,
  CAPITAL_STRUCTURE,
  DCSC_SECTORS,
} from '../directory/topic_classes/tabPaths';

export const defaultTabs = [
  {
    id: 1,
    title: 'News',
    path: 'news',
    priority: 1,
  },
];

export const filingsTab = {
  id: 2,
  title: 'Filings',
  path: 'filings',
  priority: 2,
};

export const investorRelationsTab = {
  id: 6,
  title: 'Investor Relations',
  path: 'investor-relations',
  priority: 3,
};

export const esgTab = {
  id: 7,
  title: 'ESG',
  path: 'esg',
  priority: 5,
};

export const chartsTab = {
  id: 4,
  title: 'Charts & Data',
  path: 'charts',
  priority: 7,
};

export const infoTab = {
  id: 5,
  title: 'Info',
  path: 'info',
  priority: 8,
};

export const insiderTransactionsTab = {
  id: 8,
  title: 'Insider Transactions',
  path: INSIDER_TRANSACTIONS,
  isBeta: false,
  isNew: true,
  priority: 4,
};

export const capitalStructureTab = {
  id: 9,
  title: 'Capital Structure',
  path: CAPITAL_STRUCTURE,
  isBeta: false,
  isNew: true,
  priority: 9,
};

export const sectorsTab = {
  id: 10,
  title: 'Sectors',
  path: DCSC_SECTORS,
  isBeta: false,
  isNew: false,
  isDcsc: true,
  priority: 10,
};
